<template>
  <button
    class="special-button special-button--icon-and-text special-button--facebook-sign-in"
    :class="{
      'special-button--loading': isSigningIn
    }"
    type="button"
    @click="signIn"
  >
    Continue with Facebook
    <span class="loader loader--small" />
  </button>
</template>



<script>
  import errorHandlers from '@/services/error-handlers';
  import loadScript from 'simple-load-script';
  import signInWithThirdPartyMixin from '@/mixins/sign-in-with-third-party';



  export default {
    name: 'SignInWithFacebook',

    mixins: [signInWithThirdPartyMixin],

    mounted() {
      this.loadLibrary();
    },

    methods: {
      async loadLibrary() {
        try {
          if (!window.FB) {
            const appId = '2751033058445853';
            await loadScript(`https://connect.facebook.net/en_US/sdk.js#xfbml=1&version=v8.0&appId=${appId}`);
          }
        }

        catch (error) {
          errorHandlers.silent(error);
        }
      },

      signIn() {
        window.FB.login((response) => {
          if (response.status === 'connected') {
            this.signInWithThirdPartyToken({
              credentials: {
                code: response.authResponse.accessToken,
                type: 'Facebook'
              }
            });

            // this.$triggerGoogleTrackingEvent('CreateAccountSuccess', 'Account');

            this.$triggerNewRelicEvent('CreateAccountWithFacebook', 'Information', 'Create Account With Facebook Success');
          }

          else {
            errorHandlers.generic(response, {
              fallbackMessage: 'Facebook sign in failed.'
            });

            // this.$triggerGoogleTrackingEvent('CreateAccountFailure', 'Account');

            this.$triggerNewRelicEvent('CreateAccountWithFacebook', 'Error', 'Create Account With Facebook Failure');
          }
        }, {
          scope: 'public_profile,email'
        });
      }
    }
  };
</script>
